<template>
  <div class="widget-wrapper">
    <!-- Remove Button -->
    <button class="remove-btn" @click.stop="$emit('remove')" title="Remove widget">
      <i class="fa fa-times"></i>
    </button>

    <!-- Widget Content with drag handle class for vuedraggable -->
    <div class="widget-content drag-handle">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetWrapper',

  props: {
    widgetId: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.widget-wrapper {
  position: relative;
  transition: transform 0.2s ease, opacity 0.2s ease;
  height: 100%; // Fill grid cell height

  &:hover {
    .remove-btn {
      opacity: 1;
    }

    // Show drag indicator in the header on widget hover
    :deep(.drag-indicator) {
      opacity: 1;
    }

    // Shift title to make room for drag indicator
    :deep(.section-title) {
      padding-left: 16px;
    }
  }
}

.remove-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 10;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  transition: all 0.15s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  i {
    font-size: 0.75rem;
    color: #94a3b8;
  }

  &:hover {
    background-color: #fef2f2;
    border-color: #fecaca;

    i {
      color: #ef4444;
    }
  }
}

.widget-content {
  height: 100%;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
}
</style>
